export const DEFAULT_SEO = {
  title: "",
  description: "",
  h1: "",
  h1Text: "",
  h2: "",
  h2Text: "",
  seo: "",
};
